import { Link } from 'react-router-dom';
import { useTeamStore } from '@/store/useTeamStore';
import { CharacterPortrait } from './CharacterPortrait';
import { Music2 } from 'lucide-react';

export function TeamPlaylist() {
  const { members } = useTeamStore();
  const withTracks = members.filter((m) => m.spotifyTrackId);

  if (withTracks.length === 0) return null;

  return (
    <section className="px-4 pb-4 space-y-3 border-t border-border pt-6">
      <h2 className="text-sm font-semibold text-muted-foreground flex items-center gap-2">
        <Music2 size={14} /> Team-Playlist
      </h2>
      <div className="space-y-3">
        {withTracks.map((m) => (
          <div key={m.id} className="rounded-xl border border-border p-3 space-y-2">
            <Link to={`/team/${m.id}`} className="flex items-center gap-3 hover:opacity-80 transition-opacity">
              <CharacterPortrait
                emoji={m.avatarEmoji}
                color={m.avatarColor}
                avatarImageUrl={m.avatarImageUrl}
                size="xs"
              />
              <div className="min-w-0 flex-1">
                <p className="text-sm font-medium truncate">{m.name}</p>
                <p className="text-xs text-muted-foreground truncate">{m.role}</p>
              </div>
            </Link>
            <iframe
              src={`https://open.spotify.com/embed/track/${m.spotifyTrackId}?utm_source=innerteam`}
              width="100%"
              height="80"
              frameBorder="0"
              allow="autoplay; clipboard-write; encrypted-media; fullscreen; picture-in-picture"
              loading="lazy"
              className="rounded-lg"
              title={`Spotify Player für ${m.name}`}
            />
          </div>
        ))}
      </div>
    </section>
  );
}
